// extracted by mini-css-extract-plugin
module.exports = {"not-found":"style-module_not-found_3ebHa","s-icon":"style-module_s-icon_11HBM","s-text":"style-module_s-text_3tipD","s-btn":"style-module_s-btn_1hiHU"};